import React, { useState } from "react";
import MainContainer from "../../layout/MainContainer";
import SearchBar from "../../components/SearchBar";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  IconButton,
  Tab,
  Tabs,
  TextField,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import CustomPagination from "../../components/CustomPagination";
import { useLocation, useNavigate } from "react-router-dom";
import BookingRsvpTable from "./bookingRsvpTable";
import AddNote from "../../Modals/addNote";
import CancelEventModal from "../../Modals/cancelEvent";
import EditText from "../../components/editText";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function RsvpBookingDetail() {
  const [openModal4, setOpenModal4] = React.useState(false);
  const [selectedReason, setSelectedReason] = React.useState("");

  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const [valueTabs1, setValueTabs1] = React.useState(0);
  const handleChangeTabs1 = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs1(newValue);
  };
  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1); // this goes one step back in history
  };
  const [legal3, setLegal3] = useState<string>("");

  const [open1, setOpen1] = useState(false);
  const handleCloseModal1 = () => {
    setOpen1(false);
  };
  const location = useLocation();
  const { state } = location;
  const searchParams = new URLSearchParams(location.search);
  const categoryType = searchParams.get("category");
  console.log("categoryType", categoryType);
  return (
    <>
      <MainContainer>
        <div className="main_title d_flex">
          <div className="left_s">
            <h1 className="back_arrow">
              {" "}
              <IconButton onClick={() => goBack()}>
                {" "}
                <ArrowBackIcon />{" "}
              </IconButton>{" "}
              Booking Detail
            </h1>
          </div>
          <div className="right_s">
            <SearchBar searchTerm={""} placeholder={"Search offer"} />

            <Button className="btn btn_primary">
              <img src="/static/images/filter_icon.svg" alt="icon" /> Filters
            </Button>
          </div>
        </div>

        <Box className="custom_tabs1 mb_30" sx={{ width: "100%" }}>
          <Tabs
            value={valueTabs1}
            onChange={handleChangeTabs1}
            aria-label="basic tabs example"
            className="custom_tabs_links"
          >
            <Tab label="Booking Info" {...a11yProps(0)} />
            <Tab label="Notes" {...a11yProps(1)} />
          </Tabs>
        </Box>

        <CustomTabPanel value={valueTabs1} index={0}>
          <div className="cards table_cards  v2">
            <div className="cards">
              <div className="section_title">
                <h2>{categoryType || "Booking Type"}</h2>
                <div className="btn_flex">
                  {/* <Button className="btn btn_primary">Confirm</Button> */}
                  {categoryType !== "Experience" && (
                    <Button
                      className="btn btn_primary"
                      onClick={() =>
                        navigate(`/manage-booking-resvp/edit-history?category=${categoryType}`)
                      }
                    >
                      View Edit History
                    </Button>
                  )}
                  {categoryType === "Event" && state.count === "0" ? (
                    <Button
                      className="btn btn_primary"
                      onClick={() =>
                        navigate(`/manage-booking-resvp/add-exceptional-guest`)
                      }
                    >
                      Add Exceptional Guest
                    </Button>
                  ) : null}
                  {categoryType === "Event" && (
                    <Button
                      className="btn btn_danger"
                      onClick={() => setOpenModal4(true)}
                    >
                      Cancel
                    </Button>
                  )}

                  <Button
                    className="btn btn_primary "
                    onClick={() => setOpen1(true)}
                  >
                    Add Note
                  </Button>
                  <Button className="btn btn_primary ">
                    {" "}
                    <img src="/static/images/edit_icon.svg" alt="icon" /> Edit
                    Details
                  </Button>
                </div>
              </div>

              <div className="booking_bx v2">
                <figure>
                  <img src="/static/images/booking_img.jpg" alt="img" />
                </figure>
                <div className="book_cnt">
                  <span className="tag">{categoryType || "Booking Type"}</span>
                  <h3>Candlelight Symphony</h3>

                  <p>
                    Savor the Flavors of Sucre: Where Culinary Excellence Meets
                    Creativity
                  </p>
                </div>
              </div>

              {/* <div className="gap_p view_page">
            <div className="w_25">
              <h6>Booking ID</h6>
              <p>3988</p>
            </div>
            <div className="w_25">
              <h6>Booking Date & Time</h6>
              <p>2nd-June-2025 | 6:00PM</p>
            </div>
            <div className="w_25">
              <h6>Guests</h6>
              <p>04</p>
            </div>
            <div className="w_25">
              <h6>Client Name</h6>
              <p>John Smith</p>
            </div>
            <div className="w_25">
              <h6>Client Phone</h6>
              <p>+971 (0) 567894623</p>
            </div>
            <div className="w_25">
              <h6>Client Email</h6>
              <p>john@gmail.com</p>
            </div>
            <div className="w_25">
              <h6>Location</h6>
              <p>La Marsa, Tunesia</p>
            </div>
            <div className="w_25">
              <h6>Seating preferences</h6>
              <p>
                {" "}
                <FormGroup>
                  <FormControlLabel
                    control={<Checkbox defaultChecked />}
                    label="Indoor Seating"
                  />
                </FormGroup>
              </p>
            </div>
            <div className="w_25">
              <h6>Employee Name</h6>
              <p>Abdullah</p>
            </div>
            <div className="w_25">
              <h6>Any special request or occassion</h6>
              <p>Vegan/Vegetarian Meal</p>
            </div>
          </div> */}

              <div className="gap_p view_page">
                <div className="w_25">
                  <h6>Booking ID</h6>
                  <p>3988</p>
                </div>
                {categoryType === "Dining" && (
                  <div className="w_25">
                    <h6>Booking Date & Time</h6>
                    <p>2nd-June-2025 | 6:00PM</p>
                  </div>
                )}
                {categoryType !== "Experience" && (
                  <div className="w_25">
                    <h6>Guests</h6>
                    <p>{state.count}</p>
                  </div>
                )}

                <div className="w_25">
                  <h6>Client Name</h6>
                  <p>John Smith</p>
                </div>
                <div className="w_25">
                  <h6>Client Email</h6>
                  <p>john@gmail.com</p>
                </div>

                <div className="w_25">
                  <h6>Client Phone</h6>
                  <p>+971 (0) 567894623</p>
                </div>

                <div className="w_25">
                  <h6>Date Created</h6>
                  <p>22-06-2025, 12:00 PM</p>
                </div>

                <div className="control_group w_25">
                  <h6>Seating preferences</h6>
                  <FormGroup className="prfrnc">
                    <FormControlLabel
                      control={<Checkbox />}
                      label="Indoor Seating"
                    />
                  </FormGroup>
                </div>
                {categoryType === "Event" && (
                  <>
                    <div className="w_25">
                      <h6>Type</h6>
                      <p>Paid</p>
                    </div>
                    <div className="w_25">
                      <h6>Dietary Requirements</h6>
                      <p>Vegan</p>
                    </div>
                  </>
                )}
                {/* {categoryType === "Dining" && (
                  <div className="w_25">
                    <h6>Advanced Booking Period</h6>
                    <p>3 Months</p>
                  </div>
                )} */}
                <div className="w_25">
                  <h6>Employee Name</h6>
                  <p>Abdullah</p>
                </div>

                <div className="w_25">
                  <h6>Any special request or occassion</h6>
                  <p className="yellow">
                    I want to invite my parents to the event
                  </p>
                </div>
              </div>
              {categoryType === "Event" && (
                <>
                  <div className="control_group w_100">
                    <hr />
                  </div>
                  <div className="section_title mb_20">
                    <h2>Partner Detail</h2>
                  </div>

                  <div className="gap_p view_page">
                    <div className="control_group w_25">
                      <h6>Name</h6>
                      <p>Catherine Bell</p>
                    </div>
                    <div className="control_group w_25">
                      <h6>Dietary Requirement</h6>
                      <p className="yellow">Vegan, Lactose Intolerant</p>
                    </div>
                    <div className="control_group w_25">
                      <h6>Any special request or occassion</h6>
                      <p>I want to invite my parents to the event</p>
                    </div>
                    <div className="control_group w_25">
                      <h6>Payment Status</h6>
                      <p>
                        Paid - <strong className="c_success">AED 500</strong>{" "}
                        (Samantha)
                      </p>
                    </div>
                    <div className="control_group w_25">
                      <h6>Date & Time</h6>
                      <p>22-6-2025, 11:00 AM</p>
                    </div>
                  </div>

                  <div className="control_group w_100">
                    <hr />
                  </div>
                  <div className="section_title mb_20">
                    <h2>
                      Guest Detail <span className="count">1</span>
                    </h2>
                  </div>

                  <div className="gap_p view_page">
                    <div className="control_group w_25">
                      <h6>Name</h6>
                      <p>Catherine Bell</p>
                    </div>
                    <div className="control_group w_25">
                      <h6>Email</h6>
                      <p>adam@gmail.com</p>
                    </div>
                    <div className="control_group w_25">
                      <h6>Dietary Requirement</h6>
                      <p className="yellow">Vegan, Lactose Intolerant</p>
                    </div>
                    <div className="control_group w_25">
                      <h6>Payment Status</h6>
                      <p>
                        Paid - <strong className="c_success">AED 500</strong>{" "}
                        (John)
                      </p>
                    </div>
                    <div className="control_group w_25">
                      <h6>Date & Time</h6>
                      <p>22-6-2025, 11:00 AM</p>
                    </div>
                  </div>

                  <div className="control_group w_100">
                    <hr />
                  </div>
                  <div className="section_title mb_20">
                    <h2>
                      Guest Detail <span className="count">2</span>
                    </h2>
                  </div>

                  <div className="gap_p view_page">
                    <div className="control_group w_25">
                      <h6>Name</h6>
                      <p>Catherine Bell</p>
                    </div>
                    <div className="control_group w_25">
                      <h6>Email</h6>
                      <p>adam@gmail.com</p>
                    </div>
                    <div className="control_group w_25">
                      <h6>Dietary Requirement</h6>
                      <p>Vegan, Lactose Intolerant</p>
                    </div>
                    <div className="control_group w_25">
                      <h6>Payment Status</h6>
                      <p>
                        Paid - <strong className="c_success">AED 500</strong>{" "}
                        (Guest)
                      </p>
                    </div>
                    <div className="control_group w_25">
                      <h6>Date & Time</h6>
                      <p>22-6-2025, 11:00 AM</p>
                    </div>
                  </div>
                </>
              )}
              {state?.cancel === true && (
                <>
                  {categoryType === "Dining" && (
                    <>
                      <div className="control_group w_100">
                        <hr />
                      </div>
                      <div className="section_title mb_20">
                        <h2>Canceled Details</h2>
                      </div>
                      <div className="gap_p view_page">
                        <div className="control_group w_25">
                          <h6>Charge Type</h6>
                          <p>Yes</p>
                        </div>
                        <div className="control_group w_25">
                          <h6>Charge Amount</h6>
                          <p>AED 500</p>
                        </div>
                        <div className="control_group w_25">
                          <h6>Charge Status</h6>
                          <p>Paid</p>
                        </div>
                        <div className="control_group w_25">
                          <h6>Charge Date</h6>
                          <p>22-06-2025</p>
                        </div>
                      </div>
                    </>
                  )}

                  {categoryType === "Event" && (
                    <>
                      <div className="control_group w_100">
                        <hr />
                      </div>
                      <div className="section_title mb_20">
                        <h2>Refund Details</h2>
                      </div>
                      <div className="gap_p view_page">
                        <div className="control_group w_25">
                          <h6>Total Refunded Amount</h6>
                          <p>AED 4000</p>
                        </div>
                        <div className="control_group w_25">
                          <h6>Refund Status</h6>
                          <p>Paid</p>
                        </div>
                        <div className="control_group w_25">
                          <h6>Refund Date</h6>
                          <p>22-06-2025</p>
                        </div>

                        <div className="control_group w_100">
                          <h6>Individual Refunded Amount</h6>
                          <ul className="guest_list">
                            <li>
                              <span>Partner </span>
                              <strong>AED 100</strong>
                            </li>
                            <li>
                              <span>Guest 1</span>
                              <strong>AED 100</strong>
                            </li>
                            <li>
                              <span>Guest 2</span>
                              <strong>AED 100</strong>
                            </li>

                          </ul>
                        </div>
                      </div>
                    </>
                  )}
                </>
              )}

            </div>

          </div>
          {categoryType === "Experience" && (
            <div className="cards table_cards v2">
              <div className="cards">
                <div className="gap_p view_page">
                  <div className="control_group w_33">
                    <div className="section_title">
                      <h2>Payment For User</h2>
                    </div>{" "}
                    <TextField placeholder="Amount" hiddenLabel fullWidth />
                  </div>
                  <div className="control_group w_100">
                    <div className="control_group w_100">
                      <EditText content={legal3} setContent={setLegal3} />
                    </div>
                  </div>
                </div>
                <div className="mt_30">
                  <Button className="btn btn_primary ">Save</Button>
                </div>
              </div>
            </div>
          )}
          {categoryType === "Experience" && (
            <div className="cards table_cards v2">
              <div className="cards">
                <div className="section_title">
                  <h2>Payment Details</h2>
                </div>
                <div className="gap_p view_page">
                  <div className="control_group w_25">
                    <h6>Amount</h6>
                    <p>AED 4000</p>
                  </div>
                  <div className="control_group w_50">
                    <h6>Description</h6>
                    <p>
                      Lorem ipsum dolor sit amet consectetur adipisicing elit.
                      Distinctio molestiae dignissimos amet vero veritatis
                      officiis eveniet nihil tempora a sint ipsum neque quasi
                      quod voluptates suscipit, ut mollitia perspiciatis commodi
                      assumenda? Labore, recusandae expedita aperiam omnis natus
                      dolorum obcaecati voluptates tempore, veritatis facilis
                      illum minus consequuntur aliquid magnam nulla
                      voluptatibus?
                    </p>
                  </div>
                  <div className="control_group w_25">
                    <h6>Status</h6>
                    <p>Paid</p>
                  </div>
                  <div className="control_group w_25">
                    <h6>Date & Time</h6>
                    <p>22-06-2025, 12:00 PM</p>
                  </div>
                </div>
              </div>
            </div>
          )}
        </CustomTabPanel>

        <CustomTabPanel value={valueTabs1} index={1}>
          <BookingRsvpTable />
          <CustomPagination />
        </CustomTabPanel>

        <AddNote open={open1} onClose={handleCloseModal1} setOpen={setOpen1} />
      </MainContainer>
      <CancelEventModal
        open={openModal4}
        onClose={() => setOpenModal4(false)}
        setOpen={setOpenModal4}
        selectedReason={selectedReason}
        setSelectedReason={setSelectedReason}
      />
    </>
  );
}

export default RsvpBookingDetail;
